// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"64aababc","590":"550f5eb4","595":"dedd6117"}[chunkId] + ".chunk.js";
};